// extracted by mini-css-extract-plugin
export var numberInputContainer = "_68-0";
export var startPickingButton = "_68-1";